import type { NewsLogo } from "./news-types";

import { cn } from "../../utils/classnames";

export const FeaturedNewsLogo = ({ Icon, width, className }: NewsLogo) => {
  return (
    <div className={cn("relative shrink-0", width)}>
      <Icon className={className} />
    </div>
  );
};
